// Facebook Meta Pixel Utility (GDPR Compliant Wrapper)

const PIXEL_ID = '568716168820774';

export const initPixel = () => {
    const consent = localStorage.getItem('tapesignal_cookie_consent');
    if (consent === 'accepted' && window.fbq) {
        window.fbq('init', PIXEL_ID);
        window.fbq('track', 'PageView');
        console.log("Facebook Pixel Initialized safely.");
    }
};

export const trackPixelEvent = (eventName, params = {}, eventID = null) => {
    const consent = localStorage.getItem('tapesignal_cookie_consent');
    if (consent === 'accepted' && window.fbq) {
        if (eventID) {
            window.fbq('track', eventName, params, { eventID: eventID });
        } else {
            window.fbq('track', eventName, params);
        }
        console.log(`Facebook Pixel Tracked: ${eventName}`, params);
    }
};
